<template>
  <div class="applicant-infor">
    <h1>申込者情報</h1>
    <div class="main-infor">
      <div class="infor-content">
        <h2>{{ name }} 様</h2>
        <div class="infor-address">
          <div class="address">
            <p>住所</p>
            <div class="address-item w-40">
             <span v-if="zipcode">〒 {{ zipcode }}</span>
              <div>
                <span v-if="location">
                  {{ location }}
                </span>
            </div>
            </div>
          </div>
          <div class="infor-company">
            <div class="item-infor" v-if="companyName">
              <p>会社名</p>
              <span class="companyNm">{{ companyName }}</span>
            </div>
            <div class="item-infor">
              <p>部署名</p>
              <span v-if="departmentName">{{ departmentName }}</span>
            </div>
          </div>
        </div>
        <div class="infor-contact">
          <div class="item-contact">
            <p>ご連絡先メールアドレス</p>
            <span v-if="emailAddress">{{ emailAddress }}</span>
          </div>
          <div class="item-contact">
            <p>ご連絡先電話番号</p>
            <span v-if="phoneNumber1">{{ phoneNumber1 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import _ from 'lodash'
import { GET_PROFILE } from '@/store/modules/bs_app/actions'

export default {
  data() {
    return {
      name: null,
      location: null,
      zipCode1: null,
      zipCode2: null,
      zipCode: null,
      companyName: null,
      emailAddress: null,
      phoneNumber1: null,
      firstName: null,
      familyName: null,
      address1: null,
      address2: null,
      profileInfo: {},
      departmentName: null,
      inforContact: [
        {
          contact: 'ご連絡先メールアドレス',
          infor: 'abc@abc.com'
        },
        {
          contact: 'ご連絡先電話番号1',
          infor: '自宅：03-0000-0000'
        },
        {
          contact: 'ご連絡先電話番号2',
          infor: '携帯電話：080-0000-0000'
        }
      ]
    }
  },
  mounted() {
    this.getProfileInfo()
  },
  methods: {
    getProfileInfo() {
      this.$store.dispatch(GET_PROFILE).then(
        (data) => {
          if(data) {
            this.profileInfo = data
            this.name = `${_.get(this.profileInfo, 'familyName', '')  } ${  _.get(this.profileInfo, 'firstName', '')}`
            this.location = _.get(this.profileInfo, 'addresses[0].address1', '')
            const postalCode = _.get(this.profileInfo, 'addresses[0].postalCode', '')
            if(postalCode) {  
              this.zipCode1 = postalCode.toString().substring(0, 3)
              this.zipCode2 = postalCode.toString().substring(3, 7)
              this.zipcode = `${this.zipCode1  }-${this.zipCode2}`
            }
            this.companyName = _.get(this.profileInfo, 'companyName', '')
            this.divisionName = ''
            this.emailAddress = _.get(this.profileInfo, 'email', '')
            this.phoneNumber1 = _.get(this.profileInfo, 'tel', '')
            this.firstName = _.get(this.profileInfo, 'firstName', '')
            this.familyName = _.get(this.profileInfo, 'familyName', '')
            this.address1 = _.get(this.profileInfo, 'addresses[0].address1', '')
            this.address2 = _.get(this.profileInfo, 'addresses[0].address2', '')
          }
          this.bindData()
        },
        (err) => {
          const error = err.error
          this.$toasted.error(error && error.message ? error.message : error)
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>